import type { TilePositionMinMax } from "./getTilePositionMinMax"

export default function growTilePositionMinMax(
  tpmm: TilePositionMinMax,
  growBy: number,
): void {
  tpmm.minX -= growBy
  tpmm.minY -= growBy
  tpmm.maxX += growBy
  tpmm.maxY += growBy
}